import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { never as s } from "../Util/never.js";
import { c as l } from "../index-Cu0xwYjD.js";
const a = "_defaultSpinner_181n3_1", o = "_rotate_181n3_1", c = "_skipAnimations_181n3_7", d = "_squareSpinner_181n3_12", f = "_circle_181n3_12", r = {
  defaultSpinner: a,
  rotate: o,
  skipAnimations: c,
  squareSpinner: d,
  circle: f
}, m = (i) => {
  const n = i.style ?? "default";
  switch (n) {
    case "default":
      return /* @__PURE__ */ e(
        u,
        {
          className: i.className,
          skipAnimations: i.skipAnimations
        }
      );
    case "square":
      return /* @__PURE__ */ e(
        h,
        {
          className: i.className,
          skipAnimations: i.skipAnimations
        }
      );
    default:
      return s(n);
  }
};
function u({
  className: i,
  skipAnimations: n
}) {
  return /* @__PURE__ */ e(
    "svg",
    {
      className: l(
        r.defaultSpinner,
        n && r.skipAnimations,
        i
      ),
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 1.97258C6.67352 1.97258 5.44942 2.39226 4.45132 3.10427C4.22771 3.26378 4.01544 3.43798 3.81596 3.62544C2.81783 4.5634 2.143 5.82968 1.96498 7.24617C1.89706 7.78664 1.40387 8.16971 0.863413 8.10179C0.322952 8.03387 -0.0601182 7.54068 0.00780188 7.00021C0.245264 5.11065 1.14538 3.42817 2.46514 2.18796C2.72907 1.93994 3.00991 1.70947 3.30577 1.49841C4.62808 0.555132 6.2505 0 8 0C10.5411 0 12.8096 1.17004 14.2852 2.99658C14.6275 3.4203 14.5615 4.04128 14.1378 4.38359C13.7141 4.72591 13.0931 4.65992 12.7508 4.2362C11.6357 2.8559 9.92324 1.97258 8 1.97258ZM15.1366 7.89801C15.677 7.96593 16.0601 8.45912 15.9922 8.99958C15.4955 12.9523 12.1019 15.9998 8 15.9998C5.45893 15.9998 3.19041 14.8298 1.71478 13.0032C1.37247 12.5795 1.43846 11.9585 1.86218 11.6162C2.28589 11.2739 2.90688 11.3399 3.24919 11.7636C4.36431 13.1439 6.07676 14.0272 8 14.0272C11.1071 14.0272 13.6622 11.7203 14.035 8.75362C14.1029 8.21316 14.5961 7.83009 15.1366 7.89801Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function h({
  className: i,
  skipAnimations: n
}) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "56",
      height: "56",
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: l(r.squareSpinner, i),
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#clip0_4001_1900)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
              fill: "#F3F4F6"
            }
          ),
          /* @__PURE__ */ e("g", { filter: "url(#filter0_f_4001_1900)", children: /* @__PURE__ */ e("rect", { x: "16", y: "15", width: "56", height: "56", rx: "28", fill: "#B4B7FF" }) }),
          /* @__PURE__ */ e("g", { filter: "url(#filter1_f_4001_1900)", children: /* @__PURE__ */ e(
            "rect",
            {
              x: "-24",
              y: "-38",
              width: "69",
              height: "69",
              rx: "34.5",
              fill: "#F0F9FF"
            }
          ) }),
          /* @__PURE__ */ e(
            "path",
            {
              className: l(
                r.circle,
                n && r.skipAnimations
              ),
              d: "M38.9274 14.9772C41.9578 17.5201 44.0066 21.0402 44.7207 24.9312C45.4348 28.8222 44.7696 32.8404 42.8397 36.2936C40.9097 39.7469 37.8358 42.4189 34.1476 43.8495C30.4593 45.2801 26.3877 45.3796 22.6339 44.1309C18.8802 42.8822 15.6795 40.3634 13.5832 37.0086C11.4868 33.6537 10.6261 29.6728 11.1493 25.7516C11.6726 21.8304 13.5469 18.2144 16.4495 15.5266C19.3522 12.8387 23.1013 11.2473 27.0511 11.0265",
              stroke: "#4506FF",
              strokeWidth: "4",
              strokeLinecap: "round"
            }
          )
        ] }),
        /* @__PURE__ */ t("defs", { children: [
          /* @__PURE__ */ t(
            "filter",
            {
              id: "filter0_f_4001_1900",
              x: "-18",
              y: "-19",
              width: "124",
              height: "124",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ e(
                  "feGaussianBlur",
                  {
                    stdDeviation: "17",
                    result: "effect1_foregroundBlur_4001_1900"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t(
            "filter",
            {
              id: "filter1_f_4001_1900",
              x: "-58",
              y: "-72",
              width: "137",
              height: "137",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ e(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ e(
                  "feGaussianBlur",
                  {
                    stdDeviation: "17",
                    result: "effect1_foregroundBlur_4001_1900"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ e("clipPath", { id: "clip0_4001_1900", children: /* @__PURE__ */ e(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
export {
  m as Spinner
};
